import { z } from 'zod'
import { ShoppingPromotionSchema } from '@reward-platform/shared-schemas'
import { CurrencyCodesSchema } from '@reward-platform/platform-config'
import { PriceLadderSchema, PricedPaymentOptionSchema } from '../../common'
import { CarHirePolicySchema } from '../../common/policies'

const CarExtrasOfferSchema = z.object({
  bundleId: z.string(),
  vendorRef: z.string(),
  serviceId: z.string(),
  serviceSubType: z.string(),
  name: z.string(),
  serviceCategory: z.string(),
  description: z.string(),
  serviceRef: z.string(),
  maxAllowedQuantity: z.number(),
  priceApplicabilityId: z.string(),
  cashPrice: z.number().optional(),
  aviosPrice: z.number().optional(),
  collectAmount: z.number().optional(),
})

const CarHireSelectedExtraResultSchema = z.object({
  serviceRef: z.string(),
  serviceSubType: z.string(),
  name: z.string(),
  serviceCategory: z.string(),
  description: z.string(),
})

const CarHireSelectedExtraServiceRefsSchema = z.object({
  serviceRef: z.string(),
  selectedQuantity: z.number().optional(),
  maxAllowedQuantity: z.number().optional(),
})

export const CarHireIncludedSchema = z.object({
  attribute: z.string(),
  value: z.string().optional(),
})

export type CarHireIncluded = z.infer<typeof CarHireIncludedSchema>

const CarHireOfferSchema = z.object({
  bundleId: z.string(),
  priceApplicabilityId: z.string(),
  media: z.string().default(''),
  name: z.string(),
  vehicleTransmission: z.string(),
  vehicleClassName: z.string(),
  vendorName: z.string(),
  aircon: z.string().optional(),
  doors: z.string().optional(),
  seats: z.string().optional(),
  bags: z.string().optional(),
  included: z.array(CarHireIncludedSchema).optional(),
  unlimitedMileage: z.string().optional(),
  extras: z.array(CarExtrasOfferSchema).optional(),
  selectedExtras: z.array(CarHireSelectedExtraResultSchema).optional(),
  serviceRefs: z.array(CarHireSelectedExtraServiceRefsSchema).optional(),
  cashPrice: z.number(),
  baseAmount: z.number().optional(),
  aviosPrice: z.number(),
  collectAmount: z.number(),
  pricingLadder: z.array(PriceLadderSchema).optional(),
  paymentOptions: z.array(PricedPaymentOptionSchema).optional(),
  policies: z.array(CarHirePolicySchema),
  currencyCode: CurrencyCodesSchema,
  vehicleSize: z.string(),
  promotions: z.array(ShoppingPromotionSchema).optional(),
  baseLoyalty: z.number().optional(),
})

const CarHireSelectedExtraSchema = z.object({
  priceApplicabilityId: z.string(),
  bundleRef: z.string(),
  quantity: z.number(),
})

export const CarHireExtraSelectionSchema = z.object({
  vehicleBundleRef: z.string(),
  priceApplicabilityId: z.string(),
  selectedExtras: z.array(CarHireSelectedExtraSchema),
})

export const CarHireDetailsDataTransferObjectSchema = z.object({
  recommendationId: z.string().min(1),
  correlationId: z.string().min(1),
  result: CarHireOfferSchema,
})

export type CarHireDetailsDataTransferObject = z.infer<
  typeof CarHireDetailsDataTransferObjectSchema
>

export type CarHireDetailsExtraOfferData = z.infer<typeof CarExtrasOfferSchema>
export type CarHireDetailsOffer = z.infer<typeof CarHireOfferSchema>
export type CarHireExtraSelection = z.infer<typeof CarHireExtraSelectionSchema>
